"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCROLL_SPACE = exports.REDIRECT = exports.MAX_HEIGHT = exports.HoverSource = exports.HEADER_LABEL_MOBILE = exports.DEFAULT_STYLE = exports.DEFAULT_DATA = void 0;
var DEFAULT_DATA = [{
  label: 'Round Trip',
  selectionType: 'select',
  code: 'R'
}, {
  label: 'One-way',
  selectionType: 'select',
  code: 'O'
}, {
  label: 'Multi-city',
  selectionType: 'redirect',
  code: 'M',
  url: 'https://flybeyond.airasia.com/en/landing/multicity'
}];
exports.DEFAULT_DATA = DEFAULT_DATA;
var REDIRECT = 'redirect';
exports.REDIRECT = REDIRECT;
var HEADER_LABEL_MOBILE = 'Journey Type';
exports.HEADER_LABEL_MOBILE = HEADER_LABEL_MOBILE;
var DEFAULT_STYLE = {
  PLACEHOLDER: {
    COLOR: 'neutral',
    TYPE: 'default'
  },
  DROPDOWN_ICON: {
    COLOR: 'greyDark',
    FONT_SIZE: 'titleNormal',
    ICON: 'ArrowDropDownIcon'
  },
  MOBILE_HEADER: {
    ICON: {
      COLOR: 'greyDark',
      SIZE: 'titleSmall',
      TYPE: 'CloseIcon'
    }
  },
  SELECTED_ICON: {
    COLOR: 'secondary',
    ICON_CHECK: 'CheckIcon',
    ICON_REDIRECT: 'CallMadeIcon',
    SIZE: 'titleNormal'
  }
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var HoverSource = {
  MouseOver: 'MouseOver',
  KeyBoard: 'KeyBoard'
};
exports.HoverSource = HoverSource;
var MAX_HEIGHT = 365;
exports.MAX_HEIGHT = MAX_HEIGHT;
var SCROLL_SPACE = 40;
exports.SCROLL_SPACE = SCROLL_SPACE;